import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthStoreService } from '@app/core/services/auth-store.service';

export const anonymousOnlyGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  return authStore.isAuthenticated() ? router.createUrlTree([authStore.getPostAuthRoute()]) : true;
};
